var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock-search",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#FFFFF",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.993 11.646a9 9 0 1 0 -9.318 9.348"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v5l1 1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 20.2l1.8 1.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockSearch);
export default __webpack_public_path__ + "static/media/clock_search.d1528e126b6064aad990ac772d786cb1.svg";
export { ForwardRef as ReactComponent };